import { render, staticRenderFns } from "./SparePartWizardDetailModal.vue?vue&type=template&id=e1c3c9ee"
import script from "./SparePartWizardDetailModal.vue?vue&type=script&lang=js"
export * from "./SparePartWizardDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Forder%2Frectifier-order-detail-modal%2Fsections%2Fspare-parts-section%2Fspare-part-wizard-detail-modal%2FSparePartWizardDetailModal.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports